import { cn } from '@lib/utils';

interface InfoTextProps {
  className?: string;
  children: React.ReactNode;
}

function Footnote({ className, children }: InfoTextProps) {
  const baseClassName =
    'text-3b-text-secondary text-xs font-normal leading-[18px] tracking-[0.016px] md:text-sm md:leading-[22px] md:tracking-[-0.128px]';
  return <div className={cn(baseClassName, className)}>{children}</div>;
}

export default Footnote;
